import { Component, Input, OnInit } from '@angular/core';
import { FileService } from 'src/app/services/file.service';
import { FileList, fileRequest } from 'src/app/model/request/file';
import * as _ from 'lodash';
import { Subject, debounceTime, takeUntil } from 'rxjs';

import { BaseResponse } from 'src/app/model/response/base-response';

import { ToastService } from '../toast/toast.service';

@Component({
    selector: 'app-custom-file-downloader',
    templateUrl: './custom-file-downloader.component.html',
    styleUrls: ['./custom-file-downloader.component.scss'],
    standalone: false
})
export class CustomFileDownloaderComponent implements OnInit {

  @Input() request?: fileRequest;
  @Input() requestUrl?: string;
  @Input() requestUrlDl?: string;
  @Input() requestUrlDelete?: string;
  ready: boolean = false;
  fileList: FileList[] = [];
  filterList: FileList[] = [];
  itemToDelete: number = 0;
  dialog: any;

  filterValue: string = '';

  filter: Subject<string> = new Subject<string>();
  private theEnd$ = new Subject<void>();

  constructor(
    private fileService: FileService,
    private toastService: ToastService,

  ) {
  }

  ngOnInit(): void {
    this.listFiles();

    this.filter.pipe(takeUntil(this.theEnd$), debounceTime(100)).subscribe({
      next: (value: string) => {
        console.log(value)
        this.filterList = [];
        this.fileList.forEach(file => {
          if (file.fileName.toLowerCase().includes(this.filterValue.toLowerCase())) {
            this.filterList.push(file);
          }
        })
      }
    })
  }


  listFiles() {
    this.ready = false;
    this.fileService.fileList(this.requestUrl, this.request).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (response: FileList[]) => {
        this.fileList = _.cloneDeep(response);
        this.filterList = _.cloneDeep(response);
        this.ready = true;
      }
    })
  }

  checkFilter(event: any) {
    event = event.replace(/\s/g, "");
    if (event.length > 0) {
      this.filter.next(event);
    } else {
      this.filterList = _.cloneDeep(this.fileList);
    }
  }


  download(id: number, name: string, path: string) {
    if(this.requestUrl && this.requestUrlDl){
      this.downloadAlt(path,name);
    }
    // console.log("DSGSDGHSfgfh")
    // this.uploader?.uploadData(event)
    this.fileService.downloadFile(id, path).pipe(takeUntil(this.theEnd$)).subscribe(
      {
        next: (pdf: any) => {
          console.log(pdf)
          // parse pdf with no error
          let blob = new Blob([pdf], { type: "application/pdf" });
          // download
          var downloadURL = window.URL.createObjectURL(pdf);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.download = name;
          link.target = "_blank";
          link.click();
        },
        error: (e: any) => {
          console.error("impossibile scaricare il file pdf");
          console.error(e);
        }
      })
  }

  downloadAlt( path: string, name:string) {
    // console.log("DSGSDGHSfgfh")
    // this.uploader?.uploadData(event)
    this.fileService.downloadFileAlt(path,this.requestUrlDl ?? '').pipe(takeUntil(this.theEnd$)).subscribe(
      {
        next: (pdf: any) => {
          console.log(pdf)
          // parse pdf with no error
          let blob = new Blob([pdf], { type: "application/octet-stream" });
          // download
          var downloadURL = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.download = name;
          link.target = "_blank";
          link.click();
        },
        error: (e: any) => {
          console.error("impossibile scaricare il file pdf");
          console.error(e);
        }
      })
  }


  downloadAll(codice: string) {
    // console.log("DSGSDGHSfgfh")
    // this.uploader?.uploadData(event)
    this.fileService.downloadFiles(codice).pipe(takeUntil(this.theEnd$)).subscribe(
      {
        next: (pdf: any) => {
          console.log(pdf)
          // download
          var downloadURL = window.URL.createObjectURL(pdf);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.click();
        },
        error: (e: any) => {
          console.error("impossibile scaricare il file pdf");
          console.error(e);
          this.toastService.error('Il file non è disponibile per il download, riprova più tardi');
        }
      })
  }



  deleteInit(id: number) {
    this.itemToDelete = id;

    // get the dynamics text ready
    // dialog text
    // let dialogTitle: string = this.translatePipe.transform(this.languages.Warnings.DeleteTitle);
    // let dialogBody: string = this.translatePipe.transform(this.languages.Warnings.DeleteBody);

    // // dialog body
    // let yesBtn: string = this.translatePipe.transform(this.languages.ButtonYes);
    // let noBtn: string = this.translatePipe.transform(this.languages.ButtonNo);

    // this.dialog = DialogUtility.confirm({
    //   title: dialogTitle,
    //   content: dialogBody,
    //   width: '50vh',
    //   position: { X: 'center', Y: 'center' },
    //   okButton: { click: this.deleteDialog.bind(this), text: yesBtn, cssClass: 'e-flat' },
    //   cancelButton: { text: noBtn },
    // });
  }

  // close the dialog and do the delete actions
  deleteDialog() {
    this.dialog.hide();
    this.delete();
  }

  // do the delete actions
  delete() {
    //ADD THE PATH
    // this.fileService.deleteFile(this.itemToDelete, '',this.requestUrlDelete).pipe(takeUntil(this.theEnd$)).subscribe({
    //   next: (response: BaseResponse) => {
    //     this.toastService.GenerateToast({
    //       title: this.translatePipe.transform(this.languages.Documenti.Grid.DeleteSuccess),
    //       content: '',
    //       severity: 'e-toast-success'
    //     });
    //     this.listFiles();
    //   },
    //   error: (response: BaseResponse) => {
    //     if (response.errorCode == 'FIELOK0011') {

    //       let msgDetail: string = `${response.error} ${this.translatePipe.transform(this.languages.Errors.ErrorsDetail.FieldLocked)}`;

    //       this.toastService.GenerateToast({
    //         title: this.translatePipe.transform(this.languages.Errors.FieldLocked),
    //         content: msgDetail,
    //         severity: 'e-toast-warning',
    //         life: 3000,
    //       });
    //     } else {
    //       this.toastService.GenerateToast({
    //         title: '',
    //         content: response.error,
    //         severity: 'e-toast-danger'
    //       });
    //     }
    //   }
    // });

  }
}
